const ABFieldDateTimeCore = require("../../core/dataFields/ABFieldDateTimeCore.js");
module.exports = class ABFieldDateTime extends ABFieldDateTimeCore {};
